import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
} from "./actionTypes"

export const loginUser = (user, history,callback) => {
  return {
    type: LOGIN_USER,
    payload: { user, history ,callback},
    
  }
}

export const loginSuccess = (user,userData) => {
  return {
    type: LOGIN_SUCCESS,
    payload: {user,userData}
  }
}

export const logoutUser = (sid,history) => {
  return {
    type: LOGOUT_USER,
    payload: { sid,history },
  }
}

export const logoutUserSuccess = () => {
  return {
    type: LOGOUT_USER_SUCCESS,
    payload: {},
  }
}

export const apiError = error => {
  return {
    type: API_ERROR,
    payload: error,
  }
}

